var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"text-editor-setting"},[_c('vue-editor',{staticClass:"text-editor-setting__editor",attrs:{"placeholder":_vm.placeholder,"editorToolbar":_vm.customToolbar},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }